import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { MainContext } from '@blaze-cms/nextjs-components';
import { VariantContext } from '../../ListFactory';
import BuildPBComponents from '../../../../hooks/helpers/buildPBComponents';
import Banner from '../../../Banner';
import { parsePropsToDisplay, shouldRenderWaypoint } from '../../../../helpers';

const FullRenderItem = props => {
  const {
    isInfinite,
    pageBuilderComponents,
    entityProps,
    propsToDisplay,
    entity,
    index,
    itemId,
    listTotal,
    initialOffset,
    currentListLength,
    triggerInfiniteScroll,
    parent,
    pageBuilderID,
    displayCount,
    shouldRenderBanner,
    bannerProps,
    bannerIndex
  } = props;
  const { hasGTM } = useContext(MainContext);
  const VariantComponent = useContext(VariantContext);

  if (!pageBuilderComponents) return null;
  const parsedPropsToDisplay = parsePropsToDisplay(entityProps, propsToDisplay);
  const currentItemIndex = initialOffset + index;
  const renderWaypoint =
    isInfinite && shouldRenderWaypoint(index, currentListLength, currentItemIndex, listTotal);

  const defaultContent = (
    <>
      <div className="list__item list__item--full">
        {BuildPBComponents(pageBuilderComponents, {
          parent: { ...parent, itemId, itemEntity: entity },
          hasGTM,
          pageBuilderID
        })}
      </div>
      {!VariantComponent && !!parsedPropsToDisplay.length && (
        <>{parsedPropsToDisplay.map(prop => (prop ? <span key={prop}>{prop}</span> : null))}</>
      )}
    </>
  );

  return (
    <>
      {renderWaypoint && <Waypoint onEnter={triggerInfiniteScroll} />}
      {displayCount && (
        <div className="heading heading--section heading--section--count">
          <span className="section-number">{currentItemIndex + 1}</span>
          <span className="section-total">/{listTotal}</span>
        </div>
      )}
      {VariantComponent ? (
        <VariantComponent {...props}>{defaultContent}</VariantComponent>
      ) : (
        defaultContent
      )}

      {shouldRenderBanner && <Banner {...bannerProps} renderCounter={bannerIndex} />}
    </>
  );
};

FullRenderItem.propTypes = {
  pageBuilderComponents: PropTypes.array,
  entityProps: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired,
  currentListLength: PropTypes.number.isRequired,
  listTotal: PropTypes.number.isRequired,
  initialOffset: PropTypes.number.isRequired,
  displayCount: PropTypes.bool.isRequired,
  triggerInfiniteScroll: PropTypes.func,
  entity: PropTypes.string.isRequired,
  pageBuilderID: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  shouldRenderBanner: PropTypes.bool.isRequired,
  bannerIndex: PropTypes.number.isRequired,
  propsToDisplay: PropTypes.array,
  data: PropTypes.array,
  itemsToDisplay: PropTypes.array,
  bannerProps: PropTypes.object
};

FullRenderItem.defaultProps = {
  pageBuilderComponents: null,
  data: [],
  propsToDisplay: [],
  itemsToDisplay: [],
  triggerInfiniteScroll: null,
  bannerProps: null
};

export default FullRenderItem;
